import { NgModule } from '@angular/core';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { BrowserModule } from '@angular/platform-browser';
import { RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';

import {
    MsalModule,
    MsalInterceptor,
    MSAL_INSTANCE,
    MSAL_GUARD_CONFIG,
    MSAL_INTERCEPTOR_CONFIG,
    MsalGuard,
    MsalBroadcastService,
    MsalService
} from '@azure/msal-angular';

import Aura from '@primeuix/themes/aura';
import { providePrimeNG } from 'primeng/config';
import { CardModule } from 'primeng/card';
import { ButtonModule } from 'primeng/button';

import {
    SharedModule,
    SharedSettings,
    MsalInstanceFactory,
    MsalInterceptorConfigFactory,
    MsalGuardConfigFactory,
    ApiInterceptor,
    AuthService,
    LoggingService,
    ReloadService,
    BrowserProviderService
} from 'shared';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HomeComponent } from './pages/home/home.component';
import { StyleGuideComponent } from './pages/style-guide/style-guide.component';
import { UsefulLinksComponent } from './pages/useful-links/useful-links.component';
import { UnauthorizedComponent } from './pages/unauthorized/unauthorized.component';
import { NoSitesComponent } from './pages/no-sites/no-sites.component';

import { environment } from '@environment';
import { MessageModule } from 'primeng/message';
import { TabsModule } from 'primeng/tabs';
import { StepsModule } from 'primeng/steps';
import { CdkDragPlaceholder } from "@angular/cdk/drag-drop";
import { TableModule } from 'primeng/table';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LuxonModule } from 'luxon-angular';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { DatePickerModule } from 'primeng/datepicker';
import { FileUploadModule } from 'primeng/fileupload';
import { InputTextModule } from 'primeng/inputtext';
import { SelectModule } from 'primeng/select';
import { SelectButtonModule } from 'primeng/selectbutton';
import { SplitButtonModule } from 'primeng/splitbutton';
import { TextareaModule } from 'primeng/textarea';
import { CheckboxModule } from 'primeng/checkbox';
import { RadioButtonModule } from 'primeng/radiobutton';
import { provideAnimations } from '@angular/platform-browser/animations';

@NgModule({
    declarations: [
        AppComponent,
        HomeComponent,
        StyleGuideComponent,
        UsefulLinksComponent,
        UnauthorizedComponent,
        NoSitesComponent
    ],
    imports: [
        SharedModule.forRoot(environment),
        AppRoutingModule,

        BrowserModule,
        FormsModule,
        MsalModule,
        ReactiveFormsModule,
        RouterOutlet,
        RouterLink,
        RouterLinkActive,

        CdkDragPlaceholder,
        LuxonModule,

        AutoCompleteModule,
        ButtonModule,
        CardModule,
        CheckboxModule,
        DatePickerModule,
        FileUploadModule,
        InputTextModule,
        MessageModule,
        RadioButtonModule,
        SelectButtonModule,
        SelectModule,
        SplitButtonModule,
        StepsModule,
        TabsModule,
        TableModule,
        TextareaModule,
    ],
    providers: [
        {
            provide: HTTP_INTERCEPTORS,
            useClass: MsalInterceptor,
            multi: true
        }, {
            provide: HTTP_INTERCEPTORS,
            useClass: ApiInterceptor,
            multi: true
        }, {
            provide: MSAL_INSTANCE,
            useFactory: MsalInstanceFactory,
            deps: [ LoggingService, SharedSettings, BrowserProviderService ]
        }, {
            provide: MSAL_GUARD_CONFIG,
            useFactory: MsalGuardConfigFactory,
            deps: [ SharedSettings ]
        }, {
            provide: MSAL_INTERCEPTOR_CONFIG,
            useFactory: MsalInterceptorConfigFactory,
            deps: [ SharedSettings ]
        },
        provideAnimations(),
        providePrimeNG({
            theme: {
                preset: Aura,
                options: {
                    cssLayer: {
                        name: 'primeng'
                    }
                }
            }
        }),
        MsalGuard,
        MsalBroadcastService,
        MsalService
    ],
    bootstrap: [AppComponent]
})
export class AppModule {
    constructor(authService: AuthService, reloadService: ReloadService) {
        // check login early in site startup
        authService.isAuthenticated().subscribe(_ => { });
        reloadService.Start();
    }
}
